import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Signature from './signature';
import Redirect from './redirect';
import reportWebVitals from './reportWebVitals';
import { CriiptoVerifyProvider } from '@criipto/verify-react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { CookiesProvider } from 'react-cookie';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Signature />,
  },
  {
    path: "/callback",
    element: <Redirect />,
  },
]);

// No loginHint here on purpose. Passing "appswitch:ios"/"appswitch:android" makes
// Criipto return pollUrl: null for the BankID same-device session. Their hosted page
// then polls fetch(null), which resolves to <domain>/oauth2/null and 404s right after
// the user signs. Without a hint the page supplies "appswitch:browser" itself, which
// is the correct mode when we are hosted inside the app's WebView.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <CriiptoVerifyProvider
          domain="airpark-test.criipto.id"
          clientID="urn:my:application:identifier:833481"
          redirectUri={window.location.origin + '/callback'}
        >
        <RouterProvider router={router} />
      </CriiptoVerifyProvider>
    </CookiesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
